import { Modal } from 'platform-components';
import React, { ReactElement } from 'react';

import ScrollBlock from 'common.components/scroll-block/scroll-block';

import './new-year-modal__main-content.scss';

interface Props {
    children: ReactElement[];
    mix?: string;
}

export const NewYearModalMainContent = ({ children, mix }: Props) => {
    return (
        <Modal.Content mix={mix}>
            <ScrollBlock mix="new-year-modal__main-content">{children}</ScrollBlock>
        </Modal.Content>
    );
};
